import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-stone-100 text-stone-600 py-8 md:py-12 border-t border-stone-200" data-id="element-115">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-116">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-8 pb-8 border-b border-stone-200" data-id="element-117">
          <div className="text-center md:text-left" data-id="element-118">
            <div className="text-teal-900 font-bold text-xl mb-2 flex items-center justify-center md:justify-start gap-2" data-id="element-119">
              🎓 MÉTODO CONECTA-TEA
            </div>
            <p className="text-sm max-w-sm" data-id="element-120">
              De los primeros pictogramas a la autonomía completa. Acceso
              inmediato. Material imprimible. Resultados paso a paso.
            </p>
          </div>

          <div className="flex flex-col gap-3 text-sm" data-id="element-121">
            <a href="mailto:soporte@metodoconectatea.com" className="flex items-center hover:text-teal-900 transition-colors" data-id="element-122">
              soportetupuntodigital@gmail.com
            </a>
            <a href="https://www.instagram.com/metodoconectatea" target="_blank" rel="noopener noreferrer" aria-label="Instagram @metodoconectatea" className="flex items-center hover:text-teal-900 transition-colors" data-id="element-123">
              @tu_punto_digitall
            </a>
            <a href="https://www.metodoconectatea.com" target="_blank" rel="noopener noreferrer" aria-label="Sitio web Método Conecta-TEA" className="flex items-center hover:text-teal-900 transition-colors" data-id="element-124">
              www.tupuntodigital.shop
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-stone-500" data-id="element-125">
          <p data-id="element-126">
            © Método Conecta-TEA 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}